import { useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { blogArticles } from '@/data/blog-articles';
import BlogCard from '@/components/blog/BlogCard';
import SEO from '@/components/SEO';

const BlogTag = () => {
  const { tag } = useParams<{ tag: string }>();
  const decodedTag = tag ? decodeURIComponent(tag).replace(/-/g, ' ') : '';

  const articles = useMemo(
    () => blogArticles.filter((a) => {
      const articleTags = a.tags ?? a.keywords.slice(0, 4);
      return articleTags.some((t) => t.toLowerCase().replace(/\s+/g, '-') === tag || t.toLowerCase() === decodedTag.toLowerCase());
    }),
    [tag, decodedTag]
  );

  // Tag pages : noindex follow


  return (
    <>
      <SEO
        title={`Articles sur « ${decodedTag} » | Blog Cygnature`}
        description={`Articles du blog Cygnature Production avec le tag ${decodedTag}.`}
        path={`/blog/tag/${tag}`}
        noindex
      />
      <section className="px-6 lg:px-8 py-4 bg-background border-b border-border">
        <div className="max-w-7xl mx-auto flex items-center gap-2 text-xs text-muted-foreground">
          <Link to="/" className="hover:text-primary transition-colors">Accueil</Link>
          <ChevronRight size={12} />
          <Link to="/blog" className="hover:text-primary transition-colors">Blog</Link>
          <ChevronRight size={12} />
          <span className="text-foreground">Tag : {decodedTag}</span>
        </div>
      </section>

      <section className="px-6 lg:px-8 py-16 md:py-20 bg-petrol text-petrol-foreground">
        <div className="max-w-7xl mx-auto">
          <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2">Tag</p>
          <h1 className="font-heading text-2xl md:text-4xl font-bold"># {decodedTag}</h1>
          <p className="mt-3 text-petrol-foreground/60 text-sm">{articles.length} article{articles.length > 1 ? 's' : ''}</p>
        </div>
      </section>

      <section className="px-6 lg:px-8 py-12 md:py-16 bg-background">
        <div className="max-w-7xl mx-auto">
          {articles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">{articles.map((a, i) => (<BlogCard key={a.slug} article={a} index={i} animate />))}</div>
          ) : (
            <p className="text-center text-muted-foreground text-sm py-12">Aucun article avec ce tag.</p>
          )}
        </div>
      </section>
    </>
  );
};

export default BlogTag;
